angular.module 'zc.core'

.factory 'SearchFilter', ($rootScope, $location, Meta, lib) ->

  class SearchFilter
    @_normalDefaults:
      search_term: ''
      start_at: moment().startOf('month').valueOf()
      end_at: moment().endOf('day').valueOf()

    # This should be set ONCE per page in the current page's main controller
    @pageDefaults: {}

    # The per component default values for components on the page
    @componentDefaults: {}

    @_filters:
      search_term: ''
      start_at: moment().startOf('month').valueOf()
      end_at: moment().endOf('day').valueOf()

    @get: ->
      return SearchFilter._filters

    @getDateFilterValue: (propertyName, pageDefaults) ->
      # Throw error if invalid property name given (which should never happen)
      if not _.includes ['start_at', 'end_at'], propertyName
        throw new Error('Invalid property name given!')

      # Return date timestamp from url if found
      search = $location.search()
      if search[propertyName]
        momentDate = moment(search[propertyName])
        return momentDate.startOf('day').valueOf() if propertyName == 'start_at'
        return momentDate.endOf('day').valueOf()

      # Return a date from applied filters in case page's default date isn't set
      return _.get pageDefaults, propertyName, SearchFilter._filters[propertyName]

    @getDefaultReportFilters: (reportId) ->
      reportDate = moment(parseInt(reportId))
      return {
        start_at: reportDate.startOf('month').valueOf()
        end_at: reportDate.endOf('month').valueOf()
        device: null
        device_value: null
        campaign_segment: null
        campaign_segment_value: null
      }

    @set: (searchFilters) ->
      searchFilters.start_at or= SearchFilter._normalDefaults.start_at
      searchFilters.start_at = moment(searchFilters.start_at).startOf('day').valueOf()

      searchFilters.end_at or= SearchFilter._normalDefaults.end_at
      searchFilters.end_at = moment(searchFilters.end_at).endOf('day').valueOf()

      SearchFilter._filters = searchFilters
      SearchFilter.updateLocationSearch()

    @reset: (baseObject) ->
      SearchFilter._filters = _.merge baseObject, SearchFilter.pageDefaults

    # This should be called by each component to create page defaults
    @setComponentDefaults: (componentName, params) ->
      # Sets defaults for current page, but do not empty unless already
      # empty, because multiple components can handle their own defaults
      if SearchFilter.componentDefaults[componentName]
        return

      SearchFilter.componentDefaults[componentName] = {}
      _.each params, (v,k) ->
        if SearchFilter.componentDefaults[componentName][k]
          console.warn "Trying to register SearchFilter value twice for #{k} in #{componentName}"
          return

        SearchFilter.componentDefaults[componentName][k] = v

        # use getter function if defined, otherwise just set directly
        if v.getter?
          SearchFilter._filters[k] = $location.search()[k] || v.default
          SearchFilter._filters[k + '_value'] = v.getter($location.search()[k]) || v.getter(v.default)
        else
          SearchFilter._filters[k] = $location.search()[k] || v.default
        return

    # Each component should use this to clean up their parameters because we
    # cannot reliably listen to state changes
    @removeComponentDefaults: (componentName) ->
      _.each SearchFilter.componentDefaults[componentName], (v,k) ->
        delete SearchFilter.componentDefaults[componentName][k]
      delete SearchFilter.componentDefaults[componentName]

    # When reset was called, each component should listen to the reset event
    # and give a list of components to clear their stuff
    @resetComponentDefaults: (componentName) ->
      _.each SearchFilter.componentDefaults[componentName], (v, k) ->
        SearchFilter._filters[k] = v.default
        if v.getter?
          SearchFilter._filters[k + '_value'] = v.getter(v.default)
        lib.removeFromLocationSearch(k)

    # This should be called each time some value was updated
    @updateComponentDefaults: (componentName) ->
      _.each SearchFilter.componentDefaults[componentName], (v,k) ->

        # Set the raw name if there is getter
        if v.getter? && SearchFilter._filters[k + '_value']
          SearchFilter._filters[k] = SearchFilter._filters[k + '_value'][v.keyProperty]

        # clean up $locationSearch if default value or set it up if not
        if SearchFilter._filters[k] == v.default
          lib.removeFromLocationSearch(k)
        else
          $location.search(k, SearchFilter._filters[k])

    # Page's main controller should call this to handle it's basic properties
    # on filter change
    @updateLocationSearch: () ->
      # Take away start_at and end_at if they are same as default values (this month)
      if moment(SearchFilter._filters.start_at).isSame(SearchFilter.pageDefaults.start_at)
        lib.removeFromLocationSearch('start_at')
      else
        $location.search('start_at', moment(SearchFilter._filters.start_at).format('YYYY-MM-DD'))

      if moment(SearchFilter._filters.end_at).endOf('day').isSame(SearchFilter.pageDefaults.end_at)
        lib.removeFromLocationSearch('end_at')
      else
        $location.search('end_at', moment(SearchFilter._filters.end_at).startOf('day').format('YYYY-MM-DD'))

      if SearchFilter._filters.search_term == SearchFilter.pageDefaults.search_term
        lib.removeFromLocationSearch('search_term')
      else
        $location.search('search_term', SearchFilter._filters.search_term)

    # This should be called when the view's main controller is loaded.
    # Optional per page defaults for start_at, end_at and search_term
    #
    # For example each campaign has their own campaign start_at and end_at
    # but other views have current month
    @resolveFromLocation: (pageDefaults = {}) ->
      # set defaults for current page
      SearchFilter.pageDefaults = _.merge {}, SearchFilter._normalDefaults, pageDefaults

      search = $location.search()
      SearchFilter._filters = _.merge SearchFilter._filters, SearchFilter.pageDefaults, {
        search_term: search.search_term if search.search_term
        start_at: moment(SearchFilter.getDateFilterValue('start_at', pageDefaults)).valueOf()
        end_at: moment(SearchFilter.getDateFilterValue('end_at', pageDefaults)).valueOf()
      }

  SearchFilter



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/services/search_filter_service.js.coffee